module.exports = __webpack_public_path__ + "static/media/notification.9820b8db.png";